import React from 'react';
import { Box, Divider, Link, ListItem, OrderedList, Text, useColorModeValue, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { ENERGY_MASTERS_TENANT_ID } from 'clipsal-cortex-utils/src/constants/common-constants';

import { MAC_TRADE_SERVICES_EMAIL, MAC_TRADE_SERVICES_PHONE } from '../../../common/constants';
import { useViewportType } from '../../../common/hooks/use-viewport-type';
import { selectSite } from '../../site/siteSlice';
import { SupportModal } from '../../support/SupportModal';
import { ProfilePageBase } from '../ProfilePageBase';

export function InstallationIssues() {
  const site = useSelector(selectSite);
  const isEnergyMastersSite = site.tenant_id === ENERGY_MASTERS_TENANT_ID;

  return (
    <ProfilePageBase title={'Installation Issues'}>
      {isEnergyMastersSite ? <InstallationIssuesEnergyMasters /> : <InstallationIssuesClipsalSolar />}
    </ProfilePageBase>
  );
}

function InstallationIssuesClipsalSolar() {
  const { isOpen: isSupportDialogOpen, onOpen: onOpenSupportDialog, onClose: onCloseSupportDialog } = useDisclosure();
  const { isDesktopViewport } = useViewportType();

  return (
    <OrderedList px={isDesktopViewport ? 2 : 4}>
      <ListItem data-testid="contact-installer-copy" pb={2}>
        Please contact your solar installer
      </ListItem>
      <ListItem data-testid="contact-clipsal-copy">
        If your solar installer is Clipsal Solar, please{' '}
        <Link data-testid="open-support-btn" onClick={onOpenSupportDialog} color="customBlue.500">
          click here
        </Link>
      </ListItem>
      {isSupportDialogOpen && (
        <SupportModal defaultRoute="submitTicket" isOpen={isSupportDialogOpen} onClose={onCloseSupportDialog} />
      )}
    </OrderedList>
  );
}
function InstallationIssuesEnergyMasters() {
  const { isDesktopViewport } = useViewportType();
  const bgColor = useColorModeValue('white', 'gray.900');
  return (
    <Box data-testid="installation-issues-energy-masters-list" px={isDesktopViewport ? 4 : 0}>
      <Text data-testid="contact-installer-copy" pb={2} px={4} mt={4}>
        Appliances installed by MAC Trade Services:
      </Text>

      <Box bg={bgColor} px={4} py={6} data-testid="contact-mac-copy">
        <Link
          href={`tel:${MAC_TRADE_SERVICES_PHONE.replace(/\s/g, '')}`}
          style={{ textDecoration: 'none' }}
          color="customBlue.500"
          fontWeight={'bold'}
        >
          {MAC_TRADE_SERVICES_PHONE}
        </Link>
      </Box>
      <Divider />
      <Box bg={bgColor} px={4} py={6}>
        <Link
          href={`mailto:${MAC_TRADE_SERVICES_EMAIL}`}
          style={{ textDecoration: 'none' }}
          color="customBlue.500"
          wordBreak={'break-all'}
          fontWeight={'bold'}
        >
          {MAC_TRADE_SERVICES_EMAIL}
        </Link>
      </Box>
      <Text mt={4} px={4}>
        For any other appliances, please contact your installer.
      </Text>
    </Box>
  );
}
